// src/components/VisitorCount.js
import React, { useState, useEffect } from "react";
import "./VisitorCount.css";

const VisitorCount = () => {
  const [visitorData, setVisitorData] = useState({ dailyCount: 0, yearlyCount: 0, totalCount: 0 });

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/visitor`)
      .then((res) => res.json())
      .then((data) => {
        if (data) {
          setVisitorData(data);
        }
      })
      .catch((error) => console.error("Error fetching visitor count:", error));
  }, []);

  return (
    <div className="visitor-count-container">
      <p><strong>Visitors Today:</strong> {visitorData.dailyCount}</p>
      <p><strong>Visitors This Year:</strong> {visitorData.yearlyCount}</p>
      <p><strong>Total Visitors:</strong> {visitorData.totalCount}</p>
    </div>
  );
};

export default VisitorCount;
